import { Text } from '@change/ds-core-ui';

import { Translate } from '@change-corgi/core-react/i18n';

import { usePetitionDetailsPageData } from '#src/app/pages/petitionDetails/pageContext';

export const PetitionTimestamp: React.FC<EmptyObject> = () => {
	const {
		data: {
			petition: { createdAtLocalized },
		},
	} = usePetitionDetailsPageData();

	return (
		<Text className="text-typography-strong" size="medium">
			<Translate
				value="corgi.petition_gamma.details.petition_timestamp.created_at"
				replacements={{ created_at_localized: createdAtLocalized }}
			/>
		</Text>
	);
};
